import {
  Create,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  BooleanInput,
  Button,
  usePermissions,
  useNotify,
  useRedirect,
} from "react-admin";
import { useState } from "react";
import {
  Card,
  CardContent,
  TextField,
  Checkbox,
  FormControlLabel,
  MenuItem,
} from "@mui/material";

/* -------- Question Editor -------- */
const QuestionEditor = ({ question, index, updateQuestion, removeQuestion }) => (
  <Card sx={{ mb: 2 }}>
    <CardContent>
      <TextField
        label="Question Text"
        value={question.question_text}
        onChange={(e) =>
          updateQuestion(index, "question_text", e.target.value)
        }
        fullWidth
        margin="normal"
      />

      <TextField
        select
        label="Field Type"
        value={question.field_type}
        onChange={(e) =>
          updateQuestion(index, "field_type", e.target.value)
        }
        fullWidth
        margin="normal"
      >
        <MenuItem value="text">Text</MenuItem>
        <MenuItem value="radio">Radio</MenuItem>
        <MenuItem value="checkbox">Checkbox</MenuItem>
        <MenuItem value="date">Date</MenuItem>
        <MenuItem value="select">Dropdown</MenuItem>
      </TextField>

      <FormControlLabel
        control={
          <Checkbox
            checked={question.is_required}
            onChange={(e) =>
              updateQuestion(index, "is_required", e.target.checked)
            }
          />
        }
        label="Required"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={question.add_to_table}
            onChange={(e) =>
              updateQuestion(index, "add_to_table", e.target.checked)
            }
          />
        }
        label="Add to table"
      />

      {question.add_to_table && (
        <TextField
          label="Label"
          value={question.label || ""}
          onChange={(e) => updateQuestion(index, "label", e.target.value)}
          fullWidth
          margin="normal"
        />
      )}

      {(question.field_type === "radio" ||
        question.field_type === "checkbox" ||
        question.field_type === "select") && (
        <TextField
          label="Options (comma separated)"
          value={question.options.join(",")}
          onChange={(e) =>
            updateQuestion(
              index,
              "options",
              e.target.value.split(",").map((o) => o.trim())
            )
          }
          fullWidth
          margin="normal"
        />
      )}

      <Button
        label="Delete Question"
        color="error"
        onClick={() => removeQuestion(index)}
      />
    </CardContent>
  </Card>
);

/* ---------------- Main Create Page ---------------- */
const FormCreate = () => {
  const { permissions = [] } = usePermissions();
  const [questions, setQuestions] = useState([]);
  const notify = useNotify();
const redirect = useRedirect();

  // ✅ Permission Check
  if (
    !(
      permissions.includes("forms.create") ||
      permissions.includes("forms.*") ||
      permissions.includes("*")
    )
  ) {
    return null;
  }

  const AddQuestion = () => {
    setQuestions([
      ...questions,
      {
        question_text: "",
        field_type: "text",
        is_required: false,
        add_to_table: false,
        label: "",
        options: [],
      },
    ]);
  };

  const updateQuestion = (index, key, value) => {
    const updated = [...questions];
    updated[index][key] = value;
    setQuestions(updated);
  };

  const removeQuestion = (index) => {
    setQuestions(questions.filter((_, i) => i !== index));
  };

  const transform = (data) => ({
    ...data,
    questions,
  });

  return (
    <Create title="Create Feedback Form" transform={transform}
    mutationOptions={{
    onSuccess: () => {
      notify("Form created successfully", { type: "success" });
      redirect("/forms");
    },
    onError: (error) => {
      notify(error.message || "Error creating form", { type: "error" });
    },
  }}
  >
      <SimpleForm>
        <TextInput source="title" label="Form Title" required fullWidth />

        <ReferenceInput
          source="feedback_type_id"
          reference="form-types"
          label="Feedback Type"
        >
          <SelectInput optionText="name" optionValue="id" />
        </ReferenceInput>

        <BooleanInput source="is_active" label="Is Active" />

        <h3>Questions</h3>

        {questions.map((q, index) => (
          <QuestionEditor
            key={index}
            question={q}
            index={index}
            updateQuestion={updateQuestion}
            removeQuestion={removeQuestion}
          />
        ))}

        <Button label="Add Question" onClick={AddQuestion} />
      </SimpleForm>
    </Create>
  );
};

export default FormCreate;